import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { ConsultaSolicitudesIntermediarioDTO } from '../../Model/ConsultaNeoSolicitudesIntermediarioDTO';
import { FiltrosConsultaSolicitudesIntermediarioDTO } from '../../Model/filtrosConsultaSolicitudesIntermediarioDTO';
import { SolicitudIntermediarioService } from '../../Service/solicitudIntermediario.service';
const PATRON_MONTO = '^[0-9]*$';
const LONGITUD_MAXIMA_MONTO = 20;
declare var $: any;
@Component({
    selector: 'app-consulta-desembolso-if',
    templateUrl: './consulta-desembolso-if.component.html',
    styleUrls: ['./consulta-desembolso-if.component.scss'],
    providers: [SolicitudIntermediarioService],
    standalone: false
})
export class ConsultaDesembolsoIfComponent implements OnInit {
  fechaActual: String = new Date().toLocaleDateString('en-CA');
  //Constantes para el html
  readonly LONGITUD_MAXIMA_MONTO = LONGITUD_MAXIMA_MONTO;
  // Declaracion de formulario
  consultaSolicitudesForm: UntypedFormGroup;
  // consulta
  consulta: boolean = false;
  // Lista de solicitudes
  solicitudes: ConsultaSolicitudesIntermediarioDTO[] = [];
  // Filtro consulta
  filtrosConsulta: FiltrosConsultaSolicitudesIntermediarioDTO;
  // pagination
  pageActual: Number = 1;
  totalPaginas: number = 1;
  paginaActual: number = 0;
  idCliente: any;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private user: UserService,
    private _solicitudIntermediarioService: SolicitudIntermediarioService
  ) {}
  ngOnInit(): void {
    this.idCliente = this.user.getUser().idCliente;
    this.crearFormularioConsultaSolicitudes();
    $('.selectpicker').selectpicker('refresh');
  }

  crearFormularioConsultaSolicitudes() {
    if(sessionStorage.getItem('filterConsSol')){
      var filter = JSON.parse(sessionStorage.getItem('filterConsSol'));
      this.consultaSolicitudesForm = this.formBuilder.group({
        monto: [
          filter.monto,
          [
            Validators.maxLength(LONGITUD_MAXIMA_MONTO),
            Validators.pattern(PATRON_MONTO),
          ],
        ],
        origenRecursos: [filter.origenRecursos],
        fechaInicial: [filter.fechaInicial],
        fechaFinal: [filter.fechaFinal],
        pagina: filter.pagina,
      });
      setTimeout(() => {
        $('.selectpicker').selectpicker('refresh');
      });
      sessionStorage.removeItem('filterConsSol');
      this.consultarSolicitudes();
    }else{
      this.consultaSolicitudesForm = this.formBuilder.group({
        monto: [
          null,
          [
            Validators.maxLength(LONGITUD_MAXIMA_MONTO),
            Validators.pattern(PATRON_MONTO),
          ],
        ],
        origenRecursos: [null],
        fechaInicial: [null],
        fechaFinal: [null],
        pagina: 1,
      });
    }
  }
  isValidFieldConsultaSolicitudesForm(field: string) {
    return (
      (this.consultaSolicitudesForm.get(field)?.dirty ||
        this.consultaSolicitudesForm.get(field)?.touched) &&
      this.consultaSolicitudesForm.get(field)?.invalid
    );
  }

  validarFechas() {
    let fechaInicial = new Date();
    let fechaFinal = new Date();
    if (this.campoContieneValor('fechaInicial')) {
      fechaInicial = new Date(this.obtenerValorCampo('fechaInicial'));
    }
    if (this.campoContieneValor('fechaFinal')) {
      fechaFinal = new Date(this.obtenerValorCampo('fechaFinal'));
    }
    if (fechaInicial.getTime() > fechaFinal.getTime()) {
      this.consultaSolicitudesForm.controls.fechaInicial.setErrors({
        incorrect: true,
      });
    } else {
      this.consultaSolicitudesForm.controls.fechaInicial.setErrors(null);
      this.consultaSolicitudesForm.controls.fechaFinal.setErrors(null);
    }
  }
  obtenerValorCampo(nombreCampo: string) {
    return this.consultaSolicitudesForm.get(nombreCampo).value;
  }

  cualquierCampoIngresado(): boolean {
    return (
      this.campoContieneValor('monto') ||
      this.campoContieneValor('origenRecursos') ||
      this.campoContieneValor('fechaInicial') ||
      this.campoContieneValor('fechaFinal')
    );
  }

  campoContieneValor(nombreCampo: string): boolean {
    if (this.consultaSolicitudesForm.get(nombreCampo).value) {
      return true;
    } else {
      return false;
    }
  }

  limpiarFormulario() {
    this.consultaSolicitudesForm.reset();
    this.consultaSolicitudesForm.controls.pagina.patchValue(1);
    $('.selectpicker').selectpicker('refresh');
    this.consulta = false;
  }
  //
  consultarSolicitudesForm() {
    this.consultaSolicitudesForm.controls.pagina.patchValue(1);
    this.consultarSolicitudes();
  }
  consultarSolicitudes() {
    this.filtrosConsulta = this.crearObjetoFiltrosSolicitud();
    this._solicitudIntermediarioService
      .consultarSolicitudesPorFiltro(this.filtrosConsulta)
      .subscribe(
        (response: any) => {
          this.totalPaginas = response.paginasTotales;
          this.solicitudes = response.data;
          this.paginaActual = response.paginaActual;
          if(response.data.length > 0){
            this.consulta = true;
          }else{
            this.consulta = false;
            this.mensaje();
          }
        },
        (err) => {
          console.error(err);
        }
      );
  }

  mensaje(){
    $('#mensajeModal').modal('show');
  }
  crearObjetoFiltrosSolicitud(): FiltrosConsultaSolicitudesIntermediarioDTO {
    const filtros: FiltrosConsultaSolicitudesIntermediarioDTO = {
      fechaFinal: this.obtenerValorCampo('fechaFinal'),
      fechaInicial: this.obtenerValorCampo('fechaInicial'),
      monto: this.obtenerValorCampo('monto'),
      origenRecursos: this.obtenerValorCampo('origenRecursos'),
      idCliente: Number(this.idCliente),
      excel: null,
      numPagina: this.obtenerValorCampo('pagina'),
    };
    return filtros;
  }
  generarReporte(isExcel: boolean) {
    this.filtrosConsulta.excel = isExcel;
    this._solicitudIntermediarioService
      .generarReporteSolicitudesPorFiltro(this.filtrosConsulta)
      .subscribe(
        (response: any) => {
          if (response.exitoso == true) {
            var a = document.getElementById('downloadFile');
            a.setAttribute(
              'href',
              `data:${response.mimeType};base64,${response.data}`
            );
            a.setAttribute('download', unescape(response.fileName));
            a.click();
          }
        },
        (err) => {
          console.error(err);
        }
      );
  }
  //pagination
  resetPage() {
    this.consultaSolicitudesForm.controls.pagina.patchValue(1);
  }

  selectPage(pageNumber: number) {
    this.consultaSolicitudesForm.controls.pagina.patchValue(pageNumber);
    this.consultarSolicitudes();
  }

  guardarFiltro(){
    sessionStorage.setItem('filterConsSol', JSON.stringify(this.consultaSolicitudesForm.value));
  }
}
